// extracted by mini-css-extract-plugin
export default {"buttons":"ListaRecepcionesUserView_buttons__10lNF","form":"ListaRecepcionesUserView_form__knqtg"};